module.exports = __webpack_public_path__ + "img/bo_concept_hero_billede.abd0f497.png";